










































































































































































































































































































































































































































import MemberForm from "@/components/admin/members/MemberForm.vue";
import FileUpload from "@/components/shared/FileUpload.vue";
import { IMember } from "@/models/Member.model";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ components: { MemberForm, FileUpload } })
export default class ReviewerTable extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  get hasEditAdmins() {
    return this.$store.getters.hasEditAdmins;
  }

  @Prop()
  members!: IMember[];

  member: any = {};
  newMember: IMember = {};

  edit(member: IMember) {
    const el = document.getElementById("modal");
    if (el) el.classList.add("is-active");
    this.member = Object.assign({}, member);
  }

  deleteMember(member: IMember) {
    const confirm = window.confirm(
      "Are you sure you want to delete this member? This action is irreversible."
    );
    if (confirm) this.$emit("deleteMember", member);
  }

  addMemberModal() {
    const el = document.getElementById("addMemberModal");
    if (el) el.classList.add("is-active");
  }

  closeAddModal() {
    const el = document.getElementById("addMemberModal");
    if (el) el.classList.remove("is-active");
  }
  cancelAddMember() {
    this.newMember = {};
    this.closeAddModal();
  }
  addMember() {
    this.$emit("addMember", this.newMember);
  }
  close() {
    const el = document.getElementById("modal");
    if (el) el.classList.remove("is-active");
  }

  submit = false;
  disableSubmit() {
    this.submit = true;
  }

  enableSubmit() {
    this.submit = false;
  }

  uploaded(link: string) {
    this.member.link = link;
  }

  modalChangeTitle(title: string) {
    console.log(title);
    this.member.title = title;
  }

  change() {
    if (this.member.biography) {
      const fixedBiography = this.member.biography.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );

      this.member.biography = fixedBiography;
    }
    this.$emit("updateMember", this.member);
    this.close();
  }
  updateMember(member: IMember) {
    this.$emit("updateMember", member);
  }
  updateAdmin(member: IMember) {
    this.$emit("updateAdmin", member);
  }

  getExcelSheet() {
    window.open(
      `https://admin-nanomat.herokuapp.com/api/v1/excel/members?conference=${this.conference}`
    );
  }

  compareString(m1: any, m2: any, prop: string) {
    if (m1[prop] && m2[prop]) {
      const s1 = m1[prop].toUpperCase();
      const s2 = m2[prop].toUpperCase();
      if (s1 == s2) return 0;
      if (s1 > s2) return 1;
      else return -1;
    } else return -1;
  }

  compareBool(m1: any, m2: any, prop: string) {
    const b1 = m1[prop];
    const b2 = m2[prop];
    if (b1 && b2) return 0;
    if (b1 && !b2) return -1;
    if (!b1 && !b2) return 0;
    if (!b1 && b2) return 1;
    return 0;
  }

  sorted: any = {
    firstName: false,
    lastName: false,
    email: false,
    title: false,
    country: false,
    university: false,
    articleTitle: false,
    role: false,
    reviewer: false,
    isAccepted: false,
    isFullRegistered: false,
    isReviewer: false,
  };

  unsort() {
    Object.keys(this.sorted).forEach((key) => {
      this.sorted[key] = false;
    });
  }

  sortByFirstName() {
    if (this.sorted.firstName) {
      this.members.sort((a, b) => this.compareString(b, a, "firstName"));
      this.unsort();
      this.sorted.firstName = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "firstName"));
      this.unsort();
      this.sorted.firstName = true;
    }
  }

  sortByLastName() {
    if (this.sorted.lastName) {
      this.members.sort((a, b) => this.compareString(b, a, "lastName"));
      this.unsort();
      this.sorted.lastName = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "lastName"));
      this.unsort();
      this.sorted.lastName = true;
    }
  }
  /*sortByEmail() {
    if (this.sorted.email) {
      this.members.sort((a, b) => this.compareString(b, a, "email"));
      this.unsort();
      this.sorted.email = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "email"));
      this.unsort();
      this.sorted.email = true;
    }
  }*/
  sortByTitle() {
    if (this.sorted.title) {
      this.members.sort((a, b) => this.compareString(b, a, "title"));
      this.unsort();
      this.sorted.title = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "title"));
      this.unsort();
      this.sorted.title = true;
    }
  }
  sortByCountry() {
    if (this.sorted.country) {
      this.members.sort((a, b) => this.compareString(b, a, "country"));
      this.unsort();
      this.sorted.country = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "country"));
      this.unsort();
      this.sorted.country = true;
    }
  }

  sortByUniversity() {
    if (this.sorted.university) {
      this.members.sort((a, b) => this.compareString(b, a, "university"));
      this.unsort();
      this.sorted.university = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "university"));
      this.unsort();
      this.sorted.university = true;
    }
  }
  sortByArticleTitle() {
    if (this.sorted.articleTitle) {
      this.members.sort((a, b) => this.compareString(b, a, "articleTitle"));
      this.unsort();
      this.sorted.articleTitle = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "articleTitle"));
      this.unsort();
      this.sorted.articleTitle = true;
    }
  }
  sortByRole() {
    if (this.sorted.role) {
      this.members.sort((a, b) => this.compareString(b, a, "role"));
      this.unsort();
      this.sorted.role = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "role"));
      this.unsort();
      this.sorted.role = true;
    }
  }
  sortByReviewer() {
    if (this.sorted.reviewer) {
      this.members.sort((a, b) => this.compareString(b, a, "reviewer"));
      this.unsort();
      this.sorted.reviewer = false;
    } else {
      this.members.sort((a, b) => this.compareString(a, b, "reviewer"));
      this.unsort();
      this.sorted.reviewer = true;
    }
  }
  sortByAccepted() {
    if (this.sorted.isAccepted) {
      this.members.sort((a, b) => this.compareBool(b, a, "isAccepted"));
      this.unsort();
      this.sorted.isAccepted = false;
    } else {
      this.members.sort((a, b) => this.compareBool(a, b, "isAccepted"));
      this.unsort();
      this.sorted.isAccepted = true;
    }
  }
  sortByFullyRegistered() {
    if (this.sorted.isRegistered) {
      this.members.sort((a, b) => this.compareBool(b, a, "isFullRegistered"));
      this.unsort();
      this.sorted.isRegistered = false;
    } else {
      this.members.sort((a, b) => this.compareBool(a, b, "isFullRegistered"));
      this.unsort();
      this.sorted.isRegistered = true;
    }
  }

  sortByHasSubmitted() {
    if (this.sorted.hasSubmitted) {
      this.members.sort((a, b) => this.compareBool(b, a, "hasSubmitted"));
      this.unsort();
      this.sorted.hasSubmitted = false;
    } else {
      this.members.sort((a, b) => this.compareBool(a, b, "hasSubmitted"));
      this.unsort();
      this.sorted.hasSubmitted = true;
    }
  }
  sortByIsReviewer() {
    if (this.sorted.isReviewer) {
      this.members.sort((a, b) => this.compareBool(b, a, "isReviewer"));
      this.unsort();
      this.sorted.isReviewer = false;
    } else {
      this.members.sort((a, b) => this.compareBool(a, b, "isReviewer"));
      this.unsort();
      this.sorted.isReviewer = true;
    }
  }
  sortByIsVerified() {
    if (this.sorted.isVerified) {
      this.members.sort((a, b) => this.compareBool(b, a, "isVerified"));
      this.unsort();
      this.sorted.isVerified = false;
    } else {
      this.members.sort((a, b) => this.compareBool(a, b, "isVerified"));
      this.unsort();
      this.sorted.isVerified = true;
    }
  }
}
